// extracted by mini-css-extract-plugin
module.exports = {"svg-small":"svg_svg-small__1ZwAp","svg-regular":"svg_svg-regular__28Mh6","svg-large":"svg_svg-large__2mHt7"};